import React, { useContext } from "react";
import { Card, Button } from "antd";
import { BookOutlined } from "@ant-design/icons";
import FeedbackCard from "./FeedbackCard";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { ProfileContext } from "Common/hooks/context/ProfileContext";
const SidebarSection = ({ darkMode, ratings }) => {
  const { isProfileComplete } = useContext(ProfileContext)
  const isBlocked = !isProfileComplete;
  const navigate = useNavigate();
  return (
    <>
      <Card
        title={
          <span style={{
            color: darkMode ? "rgba(255, 255, 255, 0.85)" : undefined,
            opacity: isBlocked ? 0.6 : 1,
            pointerEvents: isBlocked ? "none" : "auto"
          }}>
            <BookOutlined style={{ marginRight: 8 }} /> Your Tasks
          </span>
        }
        style={{
          borderRadius: 12,
          marginBottom: 24,
          backgroundColor: darkMode ? "#1f1f1f" : "#fff",
          borderColor: darkMode ? "#303030" : "#f0f0f0",
        }}
      >
        <Button
          type="link"
          disabled={isBlocked}
          onClick={() => !isBlocked && navigate("/assigned-groups")}
          block
          style={{ textAlign: "left", opacity: isBlocked ? 0.6 : 1, pointerEvents: isBlocked ? "none" : "auto" }}
        >
          Assigned Group
        </Button>
        <Button
          type="link"
          disabled={isBlocked}
          onClick={() => !isBlocked && navigate("/project-training")}
          block
          style={{ textAlign: "left", opacity: isBlocked ? 0.6 : 1, pointerEvents: isBlocked ? "none" : "auto" }}
        >
          Trainings
        </Button>
      </Card>

      <FeedbackCard darkMode={darkMode} ratings={ratings} />
    </>
  );
};
SidebarSection.propTypes = {
  darkMode: PropTypes.bool.isRequired,
  ratings: PropTypes.array,
};
export default SidebarSection;
